
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Modal, Form, Input, Button, Tabs, Radio, Spin, Image, message } from 'antd';
import { FaReplyAll } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { RotateRightOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

function SupportAdmin() {
    const [support, setSupport] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentSupport, setCurrentSupport] = useState(null);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50); // Changed default size to 20 based on filter example
    const [totalPages, setTotalPages] = useState(0);
    const [form] = Form.useForm();
    const [statusFilter, setStatusFilter] = useState("OPEN"); // State for status filter
    const [searchType, setSearchType] = useState('supportid'); // State for radio button selection
    const [searchValue, setSearchValue] = useState('');
    const jwt = localStorage.getItem('jwt');
    const [rotationAngle, setRotationAngle] = useState(0);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [modalImageUrl, setModalImageUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModalVisibleNew, setIsModalVisibleNew] = useState(false);

    const ViewimageView = (filename, record) => {

        if (!filename) {
            message.error('Filename is not provided');

            return setIsModalVisibleNew(false);
        }

        const sanitizedFilename = filename.replace(".jpg", "");

        if (!sanitizedFilename) {
            message.error('Invalid filename');
            return;
        }

        setLoading(true);
        setSelectedRecord(record);

        axios({
            method: 'GET',
            url: process.env.REACT_APP_API + `/user/support_image?filename=${sanitizedFilename}`,
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(response => {
            if (response && response.data) {
                const imageUrl = URL.createObjectURL(response.data);
                setModalImageUrl(imageUrl);
                setIsModalVisibleNew(true);
            } else {
                throw new Error('No image data found');
            }
        }).catch(err => {
            message.error(err.response?.data?.Error || 'Failed to fetch image');
            setIsModalVisibleNew(false);
        }).finally(() => {
            setLoading(false);
        });
    };

    const rotateImage = () => {
        setRotationAngle((prevAngle) => prevAngle + 90);
    };


    useEffect(() => {
        handleOk();
        handleOkTotal()
    }, [page, size, searchType, statusFilter]);

    const handleOk = () => {
        handleOkTotal()
        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            status: [statusFilter]
        };

        if (searchValue && (searchType === 'supportid' || searchType === 'username')) {
            postData[searchType] = [searchValue];
        }


        axios({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: process.env.REACT_APP_API + "/support/view_support",
            data: postData
        })
            .then((response) => {
                setSupport(response.data.Success);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleOkTotal = () => {
        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            status: [statusFilter]
        };

        if (searchValue && (searchType === 'supportid' || searchType === 'username')) {
            postData[searchType] = [searchValue];
        }


        axios({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: process.env.REACT_APP_API + "/support/total_pages_view_support",
            data: postData
        })
            .then((response) => {
                setTotalPages(response.data.Success);
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const handleReplyClick = (record) => {
        setCurrentSupport(record);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const handleCancelNew = () => {
        setIsModalVisibleNew(false);
        form.resetFields();
    };

    const handleFormSubmit = (values) => {
        const postData = {
            jwt: jwt,
            supportid: currentSupport.SupportID,
            reply: values.reply
        };

        axios({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url: process.env.REACT_APP_API + "/support/reply_support",
            data: postData
        })
            .then((response) => {
                toast(response.data.Success);
                setIsModalVisible(false);
                form.resetFields();
                handleOk(); // Refresh support data after reply
            })
            .catch((error) => {
                toast.error(error.response.data.Error);
            });
    };

    const handleSearchTypeChange = (e) => {
        setSearchType(e.target.value);
    };

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        setPage(1); // Reset page to 1 when changing filters
    };

    const showModal = (filename, record) => {
        if (filename) {
            setSelectedRecord(record);
            ViewimageView(filename, record);
            if (modalImageUrl) {
                URL.revokeObjectURL(modalImageUrl);
            }
        } else {
            message.error("Filename is not provided");
        }
    };

    const columns = [
        {
            title: 'Created At',
            dataIndex: 'Created_At',
            key: 'Created_At',
        },
        {
            title: 'Username',
            dataIndex: 'Username',
            key: 'Username',
        },
        {
            title: 'SupportID',
            dataIndex: 'SupportID',
            key: 'SupportID',
        },
        {
            title: 'Type',
            dataIndex: 'Type',
            key: 'Type',
            render: (text) => (
                <div className="">{text ? text : "--"}</div>
            )
        },
        {
            title: 'Subject',
            dataIndex: 'Subject',
            key: 'Subject',
            render: (text) => (
                <div className="subject-cell">{text}</div>
            ),
        },
        {
            title: "Image",
            dataIndex: "Image",
            key: "Image",
            // render: (text, record) => (
            //     <a onClick={() => showModal(record.Back)}>View</a>
            // ),
            render: (text, record) => (
                record.Image_ID ? <a onClick={() => showModal(record.Image_ID, record)}>View</a> : '--'
            ),
        },
        {
            title: 'User Messages',
            key: 'UserMessages',
            render: (text, record) => (
                <ul>
                    {record.Message.filter(msg => msg.Sender === record.Username).map((message, index) => (
                        <li className="subject-cell" key={index}>
                            {message.Message}
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            title: 'Admin Messages',
            key: 'AdminMessages',
            render: (text, record) => (
                <ul>
                    {record.Message.filter(msg => msg.Sender === 'admin').map((message, index) => (
                        <li className="subject-cell" key={index}>
                            {message.Message ? message.Message : "--"}
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            title: 'Closed On',
            dataIndex: 'Closed_On',
            key: 'Closed_On',
            render: (text) => (
                <div className="">{text ? text : "--"}</div>
            )
        },
        {
            title: 'Status',
            key: 'Status',
            render: (text, record) => (
                <div className='flex justify-center items-center'>
                    {record.Status}
                    {record.Status !== 'CLOSED' && (
                        <FaReplyAll
                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                            onClick={() => handleReplyClick(record)}
                        />
                    )}
                </div>
            ),
        },
    ]

    return (
        <>

            <div style={{ marginBottom: '20px' }} className='md:flex justify-center md:justify-end'>
                <Radio.Group onChange={handleSearchTypeChange} value={searchType} style={{ marginRight: '20px' }}>
                    <Radio value="supportid">Support ID</Radio>
                    <Radio value="username">Username</Radio>
                </Radio.Group>
                <Input.Search
                    placeholder={`Enter ${searchType === 'supportid' ? 'Support ID' : 'Username'}`}
                    onSearch={handleOk}
                    onChange={handleSearchInputChange}
                    // style={{ width: 200 }}
                    className='w-full md:w-[250px]'
                />
            </div>
            <Tabs defaultActiveKey="OPEN" className="text-black active:text-black" onChange={handleStatusFilterChange}>

                <TabPane tab="OPEN" key="OPEN">
                    <Table
                        columns={columns}
                        dataSource={support.filter(item => item.Status === 'OPEN')}
                        pagination={{
                            total: totalPages * size,
                            current: page,
                            pageSize: size,
                            onChange: (page, pageSize) => {
                                setPage(page);
                                setSize(pageSize);
                            }
                        }}
                    />
                </TabPane>
                <TabPane tab="CLOSED" key="CLOSED">
                    <Table
                        columns={columns}
                        dataSource={support.filter(item => item.Status === 'CLOSED')}
                        pagination={{
                            total: totalPages * size,
                            current: page,
                            pageSize: size,
                            onChange: (page, pageSize) => {
                                setPage(page);
                                setSize(pageSize);
                            }
                        }}
                    />
                </TabPane>
            </Tabs>
            <Modal
                title="Reply to Support Ticket"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleFormSubmit}>
                    <Form.Item
                        name="reply"
                        rules={[{ required: true, message: 'Please input your reply!' }]}
                    >
                        <Input.TextArea rows={4} placeholder="Type your reply here" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                visible={isModalVisibleNew}
                footer={null}
                title={<div>Username: {selectedRecord?.Username}</div>}
                onCancel={handleCancelNew}
                width={800}
                style={{ textAlign: 'center' }}
            >
                {loading ? (
                    <div style={{ textAlign: 'center', padding: 20 }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <>
                        <div className="flex justify-end items-center gap-4">
                            {/* <SiGooglelens    onChange={handleImageChange}  className='text-3xl text-primaryColor' /> */}
                            <Button
                                onClick={rotateImage}
                                icon={<RotateRightOutlined />}
                                className='my-5 '
                            >
                                Rotate
                            </Button>
                        </div>
                        <Image
                            width="100%"
                            src={modalImageUrl || 'https://via.placeholder.com/800'}
                            preview={false}
                            style={{
                                transform: `rotate(${rotationAngle}deg)`,
                                transition: 'transform 0.5s ease',
                                display: 'block',
                                margin: '0 auto',
                            }}
                        />
                    </>
                )}
            </Modal>
        </>
    );
}

export default SupportAdmin;

